<template>
    <div class="browser-tables">
        <div class="headers">
            Tables
            <b-button v-b-tooltip.hover title="Get fresh data" class="refresh-button" @click="getTables(true)">
                <font-awesome-icon icon="sync-alt"/>
            </b-button>
        </div>
        <div v-if="loading">
            <spinner-component></spinner-component>
        </div>
        <div v-else class="tables">
            <div class="table" v-for="(table, index) in tables" :key="index" data-toggle="collapse" v-bind:data-target="'#' + table.name">
                <i class="fa fa-table" aria-hidden="true"></i>
                <span>{{ table.name }}</span>
                <div class="fields collapse" v-bind:id="table.name">
                    <div class="field" v-for="(field, index) in table.fields" :key="index">
                        <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                        {{ field.name }}
                    </div>
                </div>
            </div>
            <div v-if="tables.length == 0"><em>No tables to display</em></div>
        </div>
    </div>
</template>
<script>
    import SpinnerComponent from './Spinner-loader.vue';
    import {mapState} from 'vuex';
    export default {
        components: {
            SpinnerComponent
        },
        props: ['connection'],
        data() {
            return {
                tables: [],
                loading: false
            }
        },
        computed: {
            ...mapState('queries', {
                connectionId: 'connectionId'
            })
        },
        created() {
            this.getTables();
        },
        watch: {
            'connectionId'(val){ // watch it
                this.getTables();
            }
        },
        methods: {
            getTables(refresh=false) {
                if (this.connection != -1) {
                    this.loading = true;
                    axios
                        .post('/connection/' + this.connectionId + '/schema/tables', {refresh})
                        .then(res => {
                            this.tables = res.data.data.tables;
                            this.loading = false;
                        })
                        .catch((error) => {
                            this.tables = [];
                            this.loading = false;
                            throw new Error(`Error retrieving tables info.`);
                        });
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .browser-tables .table {
        margin-bottom: 2px;
        font-size: 13px;
        border-bottom: 1px solid #eee;
        padding-bottom: 2px;
        padding-left: 2px;
    }

    .browser-tables .table .field {
        padding-left: 20px;
    }

    .browser-tables .headers {
        font-weight: bold;
        margin-bottom: 2px;
        padding-bottom: 2px;
    }

    .browser-tables .tables {
        background-color: #fff;
        border: 1px solid #ccc;
        padding: 10px;
        margin-bottom: 10px;

        span {
            margin-left: 4px;
        }
    }

    .refresh-button {
        padding: 0;
        margin: 0;
        background-color: inherit;
        border: 0;
        color: #444;
    }
    .refresh-button:hover {
        color: #444;
        background-color: inherit;
    }
</style>